<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'VFatherProPatientsCHCP',
  components: {},
};
</script>
